// @flow
import throttle from 'lodash/throttle'

import { background, panoramaImageContainer } from '../stylesheets/background.css'
import { getPolopolyImageElement } from './polopoly'

type propType = {
  polopolyId: ?string,
  backgroundImage: ?string,
  backgroundColor: ?string
}

let eventListener = null

export const panoramaComponent = {
  type: 'panorama',
  render(id: string, props: propType, bgInnerHTML: ?string = ''): string {
    const { backgroundImage, polopolyId, backgroundColor = '#333' } = props
    const style = `background-color: ${backgroundColor};`

    let imageElement = `<img src="${backgroundImage}"></img>`

    if (!backgroundImage && polopolyId) {
      imageElement = getPolopolyImageElement(polopolyId)
    }

    return `
    <div id="${id}" class="${background}" style="${style}">
      <div class="${panoramaImageContainer}">
        ${imageElement}
        ${bgInnerHTML}
      </div>
    </div>
  `
  },

  onCurrentChanged(currentSection) {
    if (eventListener) {
      document.removeEventListener('scroll', eventListener)
      eventListener = null
    }

    const { type } = currentSection
    if (type === 'panorama') {
      eventListener = throttle(() => handlePanoramaScroll(currentSection), 30)
      document.addEventListener('scroll', eventListener, {
        passive: true
      })
    }
  }
}

const handlePanoramaScroll = element => {
  const { y, top, height } = element.foregroundElement.getBoundingClientRect()

  const { innerHeight, innerWidth } = window

  let pxInView = innerHeight - (y || top)

  if (pxInView >= height) {
    pxInView = height
  } else if (pxInView <= 0) {
    pxInView = 0
  }
  let percentInView = pxInView / height * 100
  if (percentInView >= 100) percentInView = 100
  if (percentInView <= 0) percentInView = 0

  const imgElement = element.backgroundElement.querySelector('img')

  const { width: elWidth } = imgElement.getBoundingClientRect()
  const translateX = -(elWidth - innerWidth) * percentInView / 100
  imgElement.style.transform = `translateX(${translateX}px)`
  imgElement.style.webkitTransform = `translateX(${translateX}px)`
  imgElement.style.msTransform = `translateX(${translateX}px)`
}



// WEBPACK FOOTER //
// ./src/shared/components/panorama.js